GP.collections.Messages = Backbone.Collection.extend({
    model: GP.models.Message,
    url: '/members/msg/get_thread',
    special_msg_ids:    [1,2,3,4,5,6,7,8,9,12,13,14], // special msg_ids for rude user etc...
    initialize: function() {
        this.min_msg_id = 0;
        this.max_msg_id = 0;
        this.replied = 0;
        this.other_user_replied = 0;
        this.is_wywa = false;
        this.is_mpf = false;
        this.is_mobile = false;
        this.is_ice_breaker = false;
        this.max_safe_int = (Math.pow(2, 53)-1);
        this.has_sent = false;
        this.has_read_status = false;
        this.allow_private_vc = false;

        this.exy_user = false;
        this.hon_voted = false;
        this.unlocked_thread = false;

        this.claimable = false;
        this.claimed = false;
        this.claim_days_left = 0;
        this.claim_credit_amount = 100;
    },
    comparator: function(model) {
        // set rating if we have one (will be undefined if un-rated)
        this.rating = model.get('rating');

        // comparator looks at every incoming model by default so do any extra work
        // we need to here rather than looping over the models again somewhere else
        var msg_id = parseInt(model.get('msg_id'), 10);

        // don't set min/max msg_id if msg_id is in the special_msg_id array
        if ($.inArray(msg_id, this.special_msg_ids) === -1) {
            this.set_msg_ids(msg_id);
        }

        // this is for women only and only relevant for the last page of the thread (most recent messages)
        // its a flag so we know whether or not to display the quick_reply option (if replied == 0)
        if (model.get('sender_duid') == GP.sdata.my_user.duid) {
            this.replied = 1;
        }

        if (model.get('sender_duid') && model.get('sender_duid') != GP.sdata.my_user.duid) {
            this.other_user_replied = 1;
        }

        // for free users (for paid users each message shows this info)
        if (_.contains(model.get('tag'), 'WYWA')) {
            this.is_wywa = true;
        }
        // for free users (for paid users each message shows this info)
        if (_.contains(model.get('tag'), 'ICE_BREAKER')) {
            this.is_ice_breaker = true;
        }
        // TODO: something is messed up at the api level setting these tags for messages where direction is 'sender'
        if (model.get('direction') == 'recipient' && _.intersection(['MSG_PREF_AGE_RANGE','MSG_PREF_PICS_ONLY','MSG_PREF_LOCAL_ONLY'], model.get('tag')).length > 0) {
            this.is_mpf = true;
        }
        if (_.contains(model.get('tag'), 'MOBILE')) {
            this.is_mobile = true;
        }

        // if auth user has sent any messages
        if (model.get('direction') == 'sender') {
            this.has_sent = true;
        }

        if (model.has('other_unread')) {
            this.has_read_status = true;
        }

        // set flag for private videochat for a thread
        if (model.get('allow_private_vc')) {
            this.allow_private_vc = true;
        }

        // set flag for private videochat for a thread
        if (model.get('exy_user')) {
            this.exy_user = true;
        }

        // set flag for private videochat for a thread
        if (model.get('hon_voted')) {
            this.hon_voted = true;
        }

        // set flag for to indicate if thread has been unlocked (BRONZE USERS)
        if (model.get('unlocked_thread')) {
            this.unlocked_thread = true;
        }

        // set flag is msg thread is "claimable" i.e. able to claim 1/2 credits user paid to unlock thread
        if (model.get("claimable")) {
            this.claimable = true;
        }
        // set flag is msg thread habe been "claimed" for 1/2 credits user paid to unlock thread
        if (model.get("claimed")) {
            this.claimed = true;
        }
        // set days left to claim
        if (model.get("claim_days_left")) {
            this.claim_days_left = model.get("claim_days_left");
        }
        // set amount in credits user can claim by responding to thread
        if (model.get("claim_credit_amount")) {
            this.claim_credit_amount = model.get("claim_credit_amount");
        }

        // ------- COMPARATOR CODE --------- //
        // use the msg_id as the sort value, unless it is in the special_msg_ids array of msg_ids
        // such as rude user, rude user warning
        // if it's one of those, set the sort to the maximum integer that javascript safely allows (so it's last/largest)
        var sort_id = msg_id;
        if ($.inArray(sort_id, this.special_msg_ids) !== -1) {
            // View read status option always goes last.
            if (sort_id != 2 && sort_id != 12 && sort_id != 14) {
                sort_id = (sort_id == 3) ? this.max_safe_int - 1 : this.max_safe_int;
            }
        }
        return sort_id;
    },
    set_msg_ids: function(msg_id) {
        if (this.min_msg_id === 0 || msg_id < this.min_msg_id) {
            this.min_msg_id = msg_id;
        }
        if (this.max_msg_id === 0 || msg_id > this.max_msg_id) {
            this.max_msg_id = msg_id;
        }
    },
    reset_metadata: function() {
        this.min_msg_id = 0;
        this.max_msg_id = 0;
        this.replied = 0;
        this.is_wywa = false;
        this.is_mpf = false;
        this.is_mobile = false;
        this.allow_private_vc = false;
    }
});

